module.exports = __webpack_public_path__ + "img/hest_large.ed4a4177.jpg";